import { forwardRef as j } from "react";
import { Stack as w } from "../../../Stack/Stack.js";
import { SelectItem as N } from "../SelectItem/SelectItem.js";
import { jsx as o } from "theme-ui/jsx-runtime";
const R = j((m, n) => {
  const {
    options: h,
    selectedItem: i,
    labelHighlightedText: S,
    highlightedItemIndex: x,
    itemIndicatorPlacement: p,
    displayItemIndicator: g,
    getItemValue: e,
    getItemLabel: r,
    getItemProps: s,
    renderItemIndicator: I,
    itemSx: f,
    highlightedItemSx: y,
    disabledItemSx: b,
    selectedItemSx: A,
    ...P
  } = m, c = Array.isArray(i) ? i.map((t) => (e == null ? void 0 : e(t)) ?? t) : (i && (e == null ? void 0 : e(i))) ?? i;
  return /* @__PURE__ */ o(w, {
    ref: n,
    gap: 1,
    ...P,
    children: h.map((t, l) => {
      const d = (e == null ? void 0 : e(t)) ?? t, k = (r == null ? void 0 : r(t)) ?? String(t), a = Array.isArray(c) ? c.includes(d) : d === c, H = x === l, L = s == null ? void 0 : s({
        item: t,
        index: l
      });
      return /* @__PURE__ */ o(N, {
        label: k,
        labelHighlightedText: S,
        selected: a,
        highlighted: H,
        indicatorPlacement: p,
        displayItemIndicator: g,
        ...L ?? {},
        "aria-selected": a,
        sx: f,
        highlightedSx: y,
        selectedSx: A,
        disabledSx: b,
        renderItemIndicator: I
      }, d);
    })
  });
});
R.displayName = "SelectItemsList";
export {
  R as SelectItemsList
};
